/**
 * Returns whether the app is running in embedded mode (inside the hiring portal iframe).
 * Reads from sessionStorage which is set when the app is loaded with ?embedded=true parameter.
 */
export function getIsEmbedded(): boolean {
  return sessionStorage.getItem("hiring-embedded-mode") === "true";
}
